// Input shape guard — PSD §4.2 / P1.2. Engine layer (framework-free).
// Throws EngineError ONLY on the 5 enumerated shape errors (programming errors),
// never on numeric edge cases (which are surfaced via ValidationIssue).
import { EngineError } from './error';
export function assertInputs(inputs) {
    if (inputs === null || typeof inputs !== 'object') {
        throw new EngineError('INVALID_INPUT', 'inputs must be an object');
    }
    // 1. valuationId required
    if (!inputs.valuationId || typeof inputs.valuationId !== 'string') {
        throw new EngineError('MISSING_VALUATION_ID', 'valuationId is required');
    }
    const cap = inputs.capTableSnapshot;
    if (!cap || typeof cap !== 'object') {
        throw new EngineError('MISSING_CAP_TABLE', 'capTableSnapshot is required');
    }
    // 2. cap table must have entity name + at least one instrument shape
    if (!cap.entityName || typeof cap.entityName !== 'string') {
        throw new EngineError('MISSING_ENTITY_NAME', 'cap table entityName is required');
    }
    // 3. instruments must be an array
    if (!Array.isArray(cap.instruments)) {
        throw new EngineError('MALFORMED_INSTRUMENTS', 'cap table instruments must be an array');
    }
    // 4. assumptions object required
    if (!inputs.assumptions || typeof inputs.assumptions !== 'object') {
        throw new EngineError('MISSING_ASSUMPTIONS', 'assumptions is required');
    }
    // 5. equityValue object required
    if (!inputs.equityValue || typeof inputs.equityValue !== 'object') {
        throw new EngineError('MISSING_EQUITY_VALUE', 'equityValue is required');
    }
    if (!inputs.discounts || typeof inputs.discounts !== 'object') {
        throw new EngineError('MISSING_DISCOUNTS', 'discounts is required');
    }
    if (!inputs.compliance || typeof inputs.compliance !== 'object') {
        throw new EngineError('MISSING_COMPLIANCE', 'compliance is required');
    }
}
//# sourceMappingURL=assertInputs.js.map